import { useQuery, useQueryClient } from '@tanstack/react-query';
import { Select } from '@customerio/pluma-components/react';
import { getGoalsQueryOptions } from '@/services/db/goal/queries';
import { requireWorkspaceId } from '@/services/db/shared/workspace';
import { toIdList } from './multi-select-values';

type GoalFilterProps = {
  selectedGoalIds: readonly string[];
  onGoalIdsChange: (goalIds: string[]) => void;
};

/** Filters a list by the goals its items count toward. */
export function GoalFilter({ selectedGoalIds, onGoalIdsChange }: GoalFilterProps) {
  const qc = useQueryClient();
  // A failed read leaves the picker empty; the query's own error handling reports it.
  const goalsQuery = useQuery(getGoalsQueryOptions(requireWorkspaceId(), qc));
  const options = (goalsQuery.data ?? []).map((goal) => ({ value: goal.id, label: goal.name }));

  return (
    <Select
      size="sm"
      isMulti
      isSearchable
      isDisabled={goalsQuery.isPending}
      options={options}
      placeholder="Search goals"
      ariaLabel="Goals"
      value={[...selectedGoalIds]}
      onChange={(value: string | string[] | null) => onGoalIdsChange(toIdList(value))}
    />
  );
}
